import { render, staticRenderFns } from "./ManageDocumentSeriesAllocationModal.vue?vue&type=template&id=12f156a4&"
import script from "./ManageDocumentSeriesAllocationModal.vue?vue&type=script&lang=js&"
export * from "./ManageDocumentSeriesAllocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports